import React, { useState } from 'react';
import { Outlet, Link, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LanguageToggle, useLanguage } from '../context/LanguageContext';
import './AdminLayout.css';

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const volunteer = user?.desk_role === 'volunteer';
  const { t } = useLanguage();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const closeMenu = () => setMenuOpen(false);
  const path = location.pathname;
  const volunteerAllowed = path === '/admin/check-in' || path === '/admin/gifts';

  if (volunteer && !volunteerAllowed) {
    return <Navigate to="/admin/check-in" replace />;
  }

  return (
    <div className={`admin-layout${menuOpen ? ' menu-open' : ''}`}>
      <button
        type="button"
        className="admin-mobile-menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label={menuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
        aria-expanded={menuOpen}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      <div className={`admin-sidebar ${menuOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2>{t('nav.admin')}</h2>
          <p>{volunteer ? t('role.volunteer') : `${t('role.adminLine')}${user?.phone_number || ''}`}</p>
          <LanguageToggle />
          <button type="button" className="admin-sidebar-close" onClick={closeMenu} aria-label={t('nav.closeMenu')}>
            ✕
          </button>
        </div>
        <nav className="sidebar-nav">
          {volunteer ? (
            <>
              <Link to="/admin/check-in" onClick={closeMenu}>{t('nav.checkIn')}</Link>
              <Link to="/admin/gifts" onClick={closeMenu}>{t('nav.gifts')}</Link>
            </>
          ) : (
            <>
              <Link to="/admin" onClick={closeMenu}>{t('nav.dashboard')}</Link>
              <Link to="/admin/check-in" onClick={closeMenu}>{t('nav.checkIn')}</Link>
              <Link to="/admin/gifts" onClick={closeMenu}>{t('nav.gifts')}</Link>
              <Link to="/admin/events" onClick={closeMenu}>{t('nav.events')}</Link>
              <Link to="/admin/members" onClick={closeMenu}>{t('nav.members')}</Link>
              <Link to="/admin/content" onClick={closeMenu}>{t('nav.content')}</Link>
              <Link to="/admin/messages" onClick={closeMenu}>{t('nav.messages')}</Link>
              <Link to="/admin/advanced" onClick={closeMenu}>{t('nav.advanced')}</Link>
            </>
          )}
          <hr />
          <Link to="/" onClick={closeMenu}>{t('nav.backHome')}</Link>
          <button type="button" onClick={handleLogout} className="btn btn-secondary">{t('nav.logout')}</button>
        </nav>
      </div>

      {menuOpen && <div className="admin-sidebar-overlay" onClick={closeMenu} />}

      <div className="admin-content">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
